import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { Tab, Tabs } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { bodyStyleTabClick } from 'reaxl-analytics-handlers';

import { kbbVRSDataDuck } from '@/ducks';

import {
    bapActiveModelDuck,
    bapModelInfoDuck,
    bapSelectedOptionsDuck,
} from '@/ducks/bap';

import BuildAndPriceBodyStyleModel from './BuildAndPriceBodyStyleModel';

function BuildAndPriceBodyStyleTab({
    initialModelStyle,
    interactedChangeModelLink,
    modelCode,
    setActiveStyleTab = () => { },
}) {
    const dispatch = useDispatch();
    const activeModel = useSelector((state) => bapActiveModelDuck.selectors.getDuckState(state)) || '';
    const vrsBodyStyles = useSelector((state) => kbbVRSDataDuck.selectors.getBodyStyles(state));
    const vrsData = useSelector((state) => kbbVRSDataDuck.selectors.getData(state));
    const query = useSelector((state) => state?.query || {});

    const makeCodeList = query?.makeCode || query?.makeCodeList;
    const makeCode = !Array.isArray(makeCodeList) && makeCodeList;
    const [active, setActive] = useState('');
    const [interactedStyleTab, setInteractedStyleTab] = useState(false);

    useEffect(() => {
        if (!interactedStyleTab) {
            const vrsModels = Object.entries(_get(vrsData, `${makeCode}`, {}));
            const firstModels = Object.values(vrsModels);
            const firstModel = firstModels?.[0]?.[0];
            const doesModelExist = _get(vrsData, `${makeCode}.${modelCode}`, '');
            const activeModelCode = doesModelExist ? modelCode : firstModel;
            const vrsTrims = Object.values(_get(vrsData, `${makeCode}.${activeModelCode}`, []));
            const firstTrim = vrsTrims?.[0];

            if (activeModelCode) {
                if (vrsTrims && vrsTrims.length <= 1) {
                    dispatch(
                        kbbVRSDataDuck.creators.addModelInfo({
                            makeCode,
                            modelCode: activeModelCode,
                            selectedModel: activeModelCode,
                        })
                    );
                }
                dispatch(bapActiveModelDuck.creators.setActiveModel(activeModelCode));
            }

            if (!_isEmpty(firstTrim)) {
                const firstActiveTrim = Object.keys(vrsData?.[makeCode]?.[activeModelCode])?.[0];
                dispatch(bapModelInfoDuck.creators.setActiveTrim(firstActiveTrim));
                setActiveStyleTab(firstTrim?.bodyStyle);
                setActive(firstTrim?.bodyStyle);
            }
        }
        return () => {
            setActive('');
            // Reset the active model when the component unmounts
            dispatch(bapActiveModelDuck.creators.reset());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const doesModelExist = _get(vrsData, `${makeCode}.${modelCode}`, '');

        if (!interactedStyleTab && makeCode && (doesModelExist)) {
            const modelData = _get(vrsData, `${makeCode}`, '');
            const firstModel = modelData && Object.keys(modelData)?.[0];
            const defaultModel = activeModel || modelCode || firstModel;

            dispatch(bapActiveModelDuck.creators.setActiveModel(defaultModel));

            const vrsModels = Object.entries(_get(vrsData, `${makeCode}`, {}));
            vrsModels.forEach(([key, value]) => {
                if (key === defaultModel) {
                    const initialBodyStyle = Object.values(value)?.[0]?.bodyStyle;
                    setActiveStyleTab(initialBodyStyle);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeModel, interactedStyleTab, makeCode, modelCode, vrsData]);

    const handleStyleChange = (activeKey) => {
        if (active !== activeKey) {
            dispatch(bapSelectedOptionsDuck.creators.reset());
            const vrsModels = Object.entries(_get(vrsData, `${makeCode}`, {}));
            const modelsWithStyle = [];
            const trimsWithStyle = [];
            vrsModels.forEach(([key, value]) => {
                Object.entries(value).forEach(([trimKey, trimValue]) => {
                    if (trimValue?.bodyStyle === activeKey) {
                        modelsWithStyle.push(key);
                        trimsWithStyle.push({ trimKey, modelCode: trimValue.atcModelCode });
                    }
                });
            });

            const initialModelSelection = modelsWithStyle.includes(modelCode) ? modelCode : modelsWithStyle?.[0];

            dispatch(
                kbbVRSDataDuck.creators.addModelInfo({
                    makeCode,
                    modelCode: initialModelSelection,
                    modelsLoading: true,
                    selectedModel: initialModelSelection,
                })
            );

            setActiveStyleTab(activeKey);
            setActive(activeKey);
            setInteractedStyleTab(true);
            dispatch(bapActiveModelDuck.creators.setActiveModel(initialModelSelection || ''));
            const activeTrim = trimsWithStyle?.find((x) => x.modelCode === initialModelSelection)?.trimKey ?? trimsWithStyle?.[0]?.trimKey;
            dispatch(bapModelInfoDuck.creators.setActiveTrim(activeTrim));

            const extra = {
                inventoryId: 'preorderBAP',
                bodyStyle: activeKey?.toLowerCase(),
            };
            sendClick(bodyStyleTabClick, null, extra);
        }
    };

    const renderStyleTabs = () => Object.entries(vrsBodyStyles).map(([key, styleList]) => (
        <Tab
            eventKey={styleList[1]}
            key={`${key}-${styleList[0]}`}
            title={styleList[0]}
            className="padding-top-4"
        >
            <BuildAndPriceBodyStyleModel
                activeStyleTab={styleList[1]}
                makeCode={makeCode}
                activeModel={activeModel}
                initialModelStyle={initialModelStyle}
                interactedChangeModelLink={interactedChangeModelLink}
            />
        </Tab>
    ));

    return (
        active && (
            <Tabs
                alignment="left"
                defaultActiveKey={active}
                onSelect={handleStyleChange}
                title="ModelsByStyle"
                className="margin-4"
            >
                {renderStyleTabs()}
            </Tabs>
        )
    );
}

export default BuildAndPriceBodyStyleTab;
